import React, { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';

import { CartContext } from '../../contexts/CartContext';
import { TmAddress } from '../../tscapi/model/account';
import { TmSelectShippingAddressRequest } from '../../tscapi/model/request/account_cart-request';
import { AccountUtils } from '../../tscapi/utils/account-utils';

import { AddShippingAddress } from './shipping-address-add.component';
import { ShippingAddressEdit } from './shipping-address-edit.component';

export const ShippingAddress = () => {
    const { t } = useTranslation();
    const { cartData, updateShippingAddress, orderHistoryDetail, orderModificationMode } = useContext(CartContext);

    const [modalIsOpen, setModalOpen] = useState(false);
    const [addModalIsOpen, setAddModalIsOpen] = useState(false);
    const [editModalIsOpen, setEditModalIsOpen] = useState(false);

    const [cartShippingAddress, setCartShippingAddress] = useState(null);
    const [shippingAddressId, setShippingAddressId] = useState(0);
    const [sortedAddressList, setSortedAddressList] = useState<TmAddress[]>(null);

    const [shippingPhoneNumber, setShippingPhoneNumber] = useState('');
    const [addressToEdit, setAddressToEdit] = useState<TmAddress>({
        Id: 0,
        FirstName: '',
        LastName: '',
        DayPhone: '',
        Street: '',
        AddressRef1: '',
        City: '',
        State: '',
        ZipCode: '',
        IsDefault: false,
        POBoxNumber: '',
        IsPOBox: false,
        SalesForceAddressId: '',
    });

    const openModal = () => {
        setModalOpen(true);
    };
    const closeModal = () => {
        // setShippingAddressId(0);
        setModalOpen(false);
    };

    useEffect(() => {
        if (cartData && cartData.Buyer) {
            const accountAddressList: TmAddress[] = [];
            accountAddressList.push(cartData.Buyer.BillingAddress);

            const hasShippingAddressOnFile =
                cartData.Buyer.ShippingAddresses && cartData.Buyer.ShippingAddresses.length > 0;
            let hasShippingAddressSet = false;

            if (cartData.ShippingAddress) {
                hasShippingAddressSet = true;
                setCartShippingAddress(cartData.ShippingAddress);
                setShippingPhoneNumber(AccountUtils.formatPhoneNumber(cartData.ShippingAddress));
                if (shippingAddressId == 0) {
                    setShippingAddressId(cartData.ShippingAddress.Id);
                }
            }
            // } else if (hasShippingAddressOnFile) {
            //     setCartShippingAddress(cartData.Buyer.ShippingAddresses[0]);
            //     if (shippingAddressId == 0) {
            //         setShippingAddressId(cartData.Buyer.ShippingAddresses[0].Id);
            //     }
            // } else {
            //     setCartShippingAddress(cartData.Buyer.BillingAddress);
            //     setSortedAddressList(accountAddressList);
            //     if (shippingAddressId == 0) {
            //         setShippingAddressId(cartData.Buyer.BillingAddress.Id);
            //     }
            // }

            if (hasShippingAddressOnFile) {
                // eslint-disable-next-line prefer-spread
                accountAddressList.push.apply(accountAddressList, cartData.Buyer.ShippingAddresses);
                if (
                    cartData.ShippingAddress &&
                    accountAddressList.findIndex((x) => x.Id == cartData.ShippingAddress.Id) < 0
                ) {
                    accountAddressList.push(cartData.ShippingAddress);
                }
            }

            let defAddress: TmAddress = undefined;
            let defIndex: number = undefined;
            if (accountAddressList.length > 1 && hasShippingAddressSet) {
                accountAddressList.forEach((item, index) => {
                    if (item.Id == cartData.ShippingAddress.Id) {
                        defAddress = item;
                        defIndex = index;
                    }
                });
                if (defAddress != undefined && defIndex != undefined) {
                    accountAddressList.splice(defIndex, 1);
                    accountAddressList.splice(0, 0, defAddress);
                }
            }
            if (accountAddressList.length > 0) setSortedAddressList(accountAddressList);
        }
    }, [cartData, shippingAddressId]);

    const onShippingAddressChange = (e) => {
        setShippingAddressId(e.target.value);
    };

    const updateCartShippingAddress = () => {
        if (cartData.ShippingAddress && cartData.ShippingAddress.Id != shippingAddressId) {
            const shipAddressReq = new TmSelectShippingAddressRequest();
            shipAddressReq.ShippingAddressId = shippingAddressId;
            updateShippingAddress(shipAddressReq);
        }
        closeModal();
    };

    const openAddModal = () => {
        //closeModal();
        setModalOpen(false);
        setAddModalIsOpen(true);
    };

    const openEditModal = (address: TmAddress) => {
        //  closeModal();
        setModalOpen(false);
        setAddressToEdit(address);
        setEditModalIsOpen(true);
    };

    const cardSelected = (selected) => {
        return selected ? 'card__box--selected' : 'card__box--unselected';
    };

    Modal.setAppElement('#expressCheckout');
    return (
        <>
            <div className="shippingAddressWrap">
                <div className="shippingaddress__label">
                    <h2 className="shippingaddress__text">{t('Shipping Address')}</h2>
                </div>
                <div className="shippingaddress__description" data-qm-encrypt="true">
                    {orderModificationMode
                        ? orderHistoryDetail && (
                              <div>
                                  <div>{orderHistoryDetail.ShipLevels[0].ShipAddressee}</div>
                                  <div>
                                      <span>{orderHistoryDetail.ShipLevels[0].ShipAddress}</span>
                                  </div>
                                  <div>
                                      <span> {orderHistoryDetail.ShipLevels[0].ShipCityProvincePostalCode}</span>
                                  </div>
                              </div>
                          )
                        : cartShippingAddress && (
                              <div>
                                  <div>{cartShippingAddress.FirstName + ' ' + cartShippingAddress.LastName}</div>
                                  <div>
                                      {cartShippingAddress.IsPOBox ? (
                                          <span> {cartShippingAddress.POBoxNumber} </span>
                                      ) : (
                                          <span>{cartShippingAddress.Street}</span>
                                      )}
                                  </div>
                                  <div>
                                      {cartShippingAddress.AddressRef1 ? (
                                          <span> {cartShippingAddress.AddressRef1}</span>
                                      ) : null}
                                  </div>
                                  <div>
                                      {cartShippingAddress.City +
                                          ', ' +
                                          cartShippingAddress.State +
                                          ' ' +
                                          cartShippingAddress.ZipCode}
                                  </div>
                                  {shippingPhoneNumber}
                              </div>
                          )}
                </div>

                <>
                    {!orderModificationMode && (
                        <button
                            className="button__change"
                            onClick={openModal}
                            data-link-type="link"
                            data-link-title="shipping address"
                            data-component-type="express checkout"
                        >
                            {t('Add Change')}
                        </button>
                    )}
                </>
            </div>
            <Modal
                isOpen={modalIsOpen}
                contentLabel={t('Change Shipping Address')}
                className="modal__contentwrap"
                overlayClassName="modal__overlay"
            >
                <div className="modal__header">
                    <button className="modal__button-back" onClick={closeModal}>
                        {t('Back')}
                    </button>
                    <h3 className="shipping__modal-text">{t('Change Shipping Address')}</h3>
                    <button className="modal__button-close" onClick={closeModal}>
                        {t('Close')}
                    </button>
                </div>
                <div className="modal__body">
                    {cartData && cartData.Buyer && sortedAddressList ? (
                        <>
                            {sortedAddressList.map((address, index) => (
                                <div className="card__wrap" key={'a' + index.toString()}>
                                    <div className={cardSelected(shippingAddressId == address.Id)}>
                                        <input
                                            name="shipAddressRad"
                                            type="radio"
                                            key={'b' + index.toString()}
                                            id={'sa-' + index.toString()}
                                            checked={shippingAddressId == address.Id}
                                            onChange={onShippingAddressChange}
                                            value={address.Id}
                                            style={{ display: 'none' }}
                                        />
                                        <label
                                            className="card__label"
                                            key={'c' + index.toString()}
                                            htmlFor={'sa-' + index.toString()}
                                        >
                                            <div className="card__header">
                                                <svg
                                                    className="card__radio--selected"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 541.6 541.6"
                                                >
                                                    <path
                                                        data-name="svg 1"
                                                        d="M270.8 0a270.9 270.9 0 1 0 .2 541.8A270.9 270.9 0 0 0 270.8 0zm0 522.5c-138.7 0-251.7-113-251.7-251.7s113-251.7 251.7-251.7 251.7 113 251.7 251.7-113 251.7-251.7 251.7z"
                                                    />
                                                    <circle cx="270.8" cy="270.8" r="108.3" />
                                                </svg>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 541.6 541.6"
                                                    className="card__radio--unselected"
                                                >
                                                    <path d="M270.8 0C121.3 0 0 121.3 0 270.8s121.3 270.8 270.8 270.8 270.8-121.3 270.8-270.8S420.3 0 270.8 0zm0 522.5c-138.7 0-251.7-113-251.7-251.7s113-251.7 251.7-251.7 251.7 113 251.7 251.7-113 251.7-251.7 251.7z" />
                                                </svg>
                                                {shippingAddressId == address.Id ? <b>{t('Selected')}</b> : t('Select')}
                                                <button
                                                    className="card__button--edit button"
                                                    style={
                                                        shippingAddressId == address.Id
                                                            ? { display: 'block' }
                                                            : { display: 'none' }
                                                    }
                                                    onClick={() => openEditModal(address)}
                                                >
                                                    {t('Edit')}
                                                </button>
                                            </div>
                                            <div className="card__address" data-qm-encrypt="true">
                                                <b>{address.FirstName + ' ' + address.LastName}</b>
                                                {address.IsPOBox ? (
                                                    <div> {address.POBoxNumber} </div>
                                                ) : (
                                                    <div>{address.Street}</div>
                                                )}
                                                {address.AddressRef1 ? <div> {address.AddressRef1}</div> : null}
                                                <div>{address.City + ', ' + address.State + ' ' + address.ZipCode}</div>
                                                <div>
                                                    {address.DayPhone.slice(0, 3) +
                                                        '-' +
                                                        address.DayPhone.slice(3, 6) +
                                                        '-' +
                                                        address.DayPhone.slice(6, 10)}
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            ))}
                            <div className="card__wrap">
                                <div className="card__box--add">
                                    <button className="card__button--add" onClick={openAddModal}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 52 52"
                                            className="card__svg--add"
                                        >
                                            <path d="M26 0C11.66 0 0 11.66 0 26s11.66 26 26 26 26-11.66 26-26S40.34 0 26 0zm0 50C12.77 50 2 39.23 2 26S12.77 2 26 2s24 10.77 24 24-10.77 24-24 24z" />
                                            <path d="M38.5 25H27V14a1 1 0 1 0-2 0v11H13.5a1 1 0 1 0 0 2H25v12a1 1 0 1 0 2 0V27h11.5a1 1 0 1 0 0-2z" />
                                        </svg>
                                        {t('Add New Address')}
                                    </button>
                                </div>
                            </div>
                        </>
                    ) : null}
                </div>
                <div className="modal__footer">
                    <button className="modal__button--save button" onClick={updateCartShippingAddress}>
                        {t('Save & Continue')}
                    </button>
                </div>
            </Modal>

            {addModalIsOpen && (
                <AddShippingAddress
                    openAddModal={addModalIsOpen}
                    setAddModalIsOpen={setAddModalIsOpen}
                    setOpenParentModal={setModalOpen}
                />
            )}

            {editModalIsOpen && (
                <ShippingAddressEdit
                    openEditModal={editModalIsOpen}
                    setEditModalIsOpen={setEditModalIsOpen}
                    selectedAddress={addressToEdit}
                    setSelectedAddress={setAddressToEdit}
                    setOpenParentModal={setModalOpen}
                />
            )}
        </>
    );
};
